import type { StatusAtividade } from "../types";

/**
 * Codificação por forma (glifo) + rótulo, nunca só cor — e nunca vermelho.
 * `sensivel` usa a família ardósia/lavanda (não erro): é um dado a respeitar
 * (aversão ou risco físico), não um fracasso. Reaproveita as classes .badge do app.
 */
const MAPA: Record<
  StatusAtividade,
  { classe: string; glifo: string; rotulo: string }
> = {
  favorita: { classe: "badge-seguro", glifo: "★", rotulo: "favorita" },
  em_exploracao: { classe: "badge-teste", glifo: "◐", rotulo: "em exploração" },
  sensivel: { classe: "badge-recusado", glifo: "◍", rotulo: "sensível" },
  nao_usada: { classe: "badge-naooferecido", glifo: "◌", rotulo: "não usada" },
};

export function StatusAtividadeBadge({ status }: { status: StatusAtividade }) {
  const m = MAPA[status];
  return (
    <span className={`badge ${m.classe}`}>
      <span className="glifo" aria-hidden>
        {m.glifo}
      </span>
      {m.rotulo}
    </span>
  );
}
